module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icon-respect-30d91ccd0ca77b8fd2ae771148c7cd7f.svg";